import { Component, input } from '@angular/core';

@Component({
  selector: 'ziro-search-result-section',
  templateUrl: './search-result-section.component.html',
  styleUrls: ['./search-result-section.component.scss'],
  standalone: false,
})
export class ZiroSearchResultSectionComponent {
  readonly resultsCount = input<number>();
  readonly heading = input<string>();
}
